import {useEffect, useState} from 'react'

export const useDebounce = (value, delay = 300, debounceCallback = () => {}) => {
  const [debouncedValue, setDebouncedValue] = useState(value)

  useEffect(() => {
    const timer = setTimeout(() => {
      debounceCallback()
      setDebouncedValue(value)
    }, delay)

    return () => {
      clearTimeout(timer)
    }
  }, [value, delay, debounceCallback])

  return debouncedValue
}
